// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#input input,select {
  height: 43px;
  border: 1px solid #797979;
  border-radius: 4px;
  margin-bottom: 2px;
  outline: none;
  padding: 0px 20px 0 9px;
  color: #000000;
}

select:selectedindex {
  color: black;
}

#input label {
  font-weight: 500;
  padding: 5px 0px 5px 0px;
  color: #000000;
  font-size: 12px;
}

select {
  padding: 0px 19px;
}

button,select {
  text-transform: none;
  padding: 0px 19px;
}

button,input,optgroup,select,textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

select {
  padding: 0px 9px;
}

#input select option {
  height: 46px;
  border-bottom: 1px solid black;
}

#addDancerinput, #editDancerinput {
    padding: 0px 12px !important;
}

.formikSelect {
    height: 42px;
}

.formikSelect {
    -webkit-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: 4%;
    background-position: top 50% right 4%;
    width: 248px;
}

select {
    word-wrap: normal;
    text-overflow: ellipsis !important;
}

.custom-select {
  position: relative;
  font-family: Arial;
}

.custom-select select {
  display: none; /*hide original SELECT element:*/
}

.select-selected {
  background-color: DodgerBlue;
}

/*style the arrow inside the select element:*/
.select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #fff transparent transparent transparent;
}

/*point the arrow upwards when the select box is open (active):*/
.select-selected.select-arrow-active:after {
  border-color: transparent transparent #fff transparent;
  top: 7px;
}

/*style the items (options), including the selected item:*/
.select-items div,.select-selected {
  color: #ffffff;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/*style items (options):*/
.select-items {
  position: absolute;
  background-color: DodgerBlue;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

/*hide the items when the select box is closed:*/
.select-hide {
  display: none;
}

.select-items div:hover, .same-as-selected {
  background-color: rgba(0, 0, 0, 0.1);
}

@media (min-width: 1200px) and (max-width: 1400px) {
  #input label {
    font-weight: 500;
    padding: 5px 0px 5px 0px;
    color: #000000;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/formik/style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,yDAA6Z;IAC7Z,4BAA4B;IAC5B,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,sDAAsD;AACxD;;AAEA,gEAAgE;AAChE;EACE,sDAAsD;EACtD,QAAQ;AACV;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,oEAAoE;EACpE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":["#input input,select {\n  height: 43px;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  margin-bottom: 2px;\n  outline: none;\n  padding: 0px 20px 0 9px;\n  color: #000000;\n}\n\nselect:selectedindex {\n  color: black;\n}\n\n#input label {\n  font-weight: 500;\n  padding: 5px 0px 5px 0px;\n  color: #000000;\n  font-size: 12px;\n}\n\nselect {\n  padding: 0px 19px;\n}\n\nbutton,select {\n  text-transform: none;\n  padding: 0px 19px;\n}\n\nbutton,input,optgroup,select,textarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nselect {\n  padding: 0px 9px;\n}\n\n#input select option {\n  height: 46px;\n  border-bottom: 1px solid black;\n}\n\n#addDancerinput, #editDancerinput {\n    padding: 0px 12px !important;\n}\n\n.formikSelect {\n    height: 42px;\n}\n\n.formikSelect {\n    -webkit-appearance: none;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==);\n    background-repeat: no-repeat;\n    background-size: 4%;\n    background-position: top 50% right 4%;\n    width: 248px;\n}\n\nselect {\n    word-wrap: normal;\n    text-overflow: ellipsis !important;\n}\n\n.custom-select {\n  position: relative;\n  font-family: Arial;\n}\n\n.custom-select select {\n  display: none; /*hide original SELECT element:*/\n}\n\n.select-selected {\n  background-color: DodgerBlue;\n}\n\n/*style the arrow inside the select element:*/\n.select-selected:after {\n  position: absolute;\n  content: \"\";\n  top: 14px;\n  right: 10px;\n  width: 0;\n  height: 0;\n  border: 6px solid transparent;\n  border-color: #fff transparent transparent transparent;\n}\n\n/*point the arrow upwards when the select box is open (active):*/\n.select-selected.select-arrow-active:after {\n  border-color: transparent transparent #fff transparent;\n  top: 7px;\n}\n\n/*style the items (options), including the selected item:*/\n.select-items div,.select-selected {\n  color: #ffffff;\n  padding: 8px 16px;\n  border: 1px solid transparent;\n  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;\n  cursor: pointer;\n  user-select: none;\n}\n\n/*style items (options):*/\n.select-items {\n  position: absolute;\n  background-color: DodgerBlue;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 99;\n}\n\n/*hide the items when the select box is closed:*/\n.select-hide {\n  display: none;\n}\n\n.select-items div:hover, .same-as-selected {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n@media (min-width: 1200px) and (max-width: 1400px) {\n  #input label {\n    font-weight: 500;\n    padding: 5px 0px 5px 0px;\n    color: #000000;\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
